import { render, staticRenderFns } from "./StaffInput.vue?vue&type=template&id=90111480&scoped=true&"
import script from "./StaffInput.vue?vue&type=script&lang=ts&"
export * from "./StaffInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90111480",
  null
  
)

export default component.exports